import DOMPurify from 'dompurify'
import { createNotificationsPlugin, NotificationsApi } from '@space/notifications'

import { httpClient, getApiBaseUrl } from '@/shared/api/httpClient'
import { linkifyHtml } from '@/shared/utils/linkifyHtml'
import { formatFlowTerminology } from '@/shared/utils/flowTerminology'

export class GonkaNotificationsApi extends NotificationsApi {
  async fetchNotifications() {
    const result = await super.fetchNotifications()
    const notifications = Array.isArray(result.notifications) ? result.notifications : []

    return {
      ...result,
      unreadCount: Number.isFinite(Number(result.unreadCount)) ? Number(result.unreadCount) : notifications.filter(notification => notification.new === 1).length,
      notifications: notifications.map((notification) => ({
        ...notification,
        name: formatFlowTerminology(notification.name),
        text: formatFlowTerminology(notification.text),
      })),
    }
  }
}

const notificationsApi = new GonkaNotificationsApi(httpClient, {
  baseURL: getApiBaseUrl(),
})

export const notificationsPlugin = createNotificationsPlugin({
  api: notificationsApi,
  autoFetch: false, // Don't fetch until user is authenticated
  sanitizeHtml: (html) => linkifyHtml(DOMPurify.sanitize(formatFlowTerminology(html), {
    ADD_ATTR: ['target', 'class', 'tagName', 'size'],
    RETURN_TRUSTED_TYPE: false,
  }) as unknown as string),
  formatDate: (value) => value,
})
